import { render, staticRenderFns } from "./MassiveRecommendations.vue?vue&type=template&id=8f5550c8&scoped=true"
import script from "./MassiveRecommendations.vue?vue&type=script&lang=js"
export * from "./MassiveRecommendations.vue?vue&type=script&lang=js"
import style0 from "./MassiveRecommendations.vue?vue&type=style&index=0&id=8f5550c8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5550c8",
  null
  
)

export default component.exports